export const formatToShortString = (value: number) => {
    if (value > 1000000) {
        return formatMillion(value);
    } else if (value > 1000) {
        return formatThousands(value);
    } else {
        return '0';
    }
};

export const formatMillion = (value: number) =>
    `${(value / 1000000).toFixed(2).toString()}M`;

export const formatThousands = (value: number) =>
    `${(value / 1000).toFixed(2).toString()}K`;
